<template>
  <div class="row">
    <template v-if="rentType === 'subscription'">
      <template v-if="!isEnoughPoints">
        <label class="col-xs-12 uppercase" for="">{{ $t("Pick a plan") }}</label>
        <div v-for="subscription in subscriptions" :key="subscription.name" class="radio-input mt5 relative flexible mb20">
          <input
            :id="subscription.name + 'subscription'"
            type="radio"
            name="delivery"
            :value="subscription"
            v-model="selectedSubscription"
            @change="updateSubscription()"
          >
          <label :for="subscription.name + 'subscription'" class="radioStyled">
            <p class="m0 fs10 lh10">{{ subscription.name }}</p>
            <p class="m0 fs-medium lh25"><b>{{ subscription.points }}</b></p>
            <p class="m0 fs10 lh10">{{ $t('items') }}</p>
            <p class="m0 fs-medium-small"><b>{{ parseDesc(subscription.description) | price(storeView) }}</b></p>
          </label>
        </div>
      </template>
      <div class="col-xs-12">
        <add-to-cart
          v-if="!isEnoughPoints"
          text="Get started"
          @click.native="showActivateSubscriptionModal"
          :product="selectedSubscription"
          :disabled="!isSelectedSubscription"
          :validation="activateSubscriptionValidation"
          class="col-xs-12 uppercase py10 w-100"
        />
        <add-to-cart
          v-else-if="isEnoughPoints && isLogged"
          text="Rent in subscription"
          @click-add-to-cart="validateProduct()"
          :product="getCurrentProduct"
          class="col-xs-12 uppercase py10 w-100"
        />
      </div>
    </template>
    <template v-if="rentType === 'single' || rentType === 'tryOn'">
      <div class="col-xs-12">
        <add-to-cart
          text="Add to cart"
          @click-add-to-cart="validateProduct()"
          :validation="getDate"
          :product="getCurrentProduct"
          :disabled="isAddToCartDisabled"
          class="col-xs-12 uppercase py10 w-100"
        />
      </div>
    </template>
    <!-- v-show below because of issue - client not matching server -->
    <div v-show="isInstantCheckoutRegistered && !isVirtualInCart && !(isSubscriptionAvaliable && isEnoughPoints)">
      <p class="col-xs-12 cl-gray instant-info weight-400 fs13">
        {{ $t('By clicking on one of the following payment method buttons, you confirm that you have read, understood and accept our') }}
        <router-link class="cl-black no-underline" target="_blank" rel="noreferrer" :to="localizedRoute('/i/' + $t('rules'))" exact>
          {{ $t('Rules') }}
        </router-link>{{ $t('and') }}
        <router-link class="cl-black no-underline" target="_blank" rel="noreferrer" :to="localizedRoute('/i/' + $t('privacy-policy'))" exact>
          {{ $t('Privacy policyV2') }}
        </router-link>
      </p>
      <div class="col-xs-12">
        <no-ssr>
          <instant-checkout :product="rentType === 'subscription' ? selectedSubscription : getCurrentProduct" :validation="instantCheckoutValidation" :disabled="isAddToCartDisabled" @click-add-to-cart="validateProduct()" />
        </no-ssr>
      </div>
    </div>
    <div class="col-xs-12 align-center">
      <span class="cl-error h5 w-100" v-if="isAddToCartDisabled && !getDeliveries.length && !getIsStockInfoLoading">{{ $t('Brak produktu na stanie') }}</span>
      <span class="cl-error h5 w-100" v-else-if="rentType === 'tryOn' && isCartFullOfTryOn && getActiveRentPeriod === 3">{{ $t('Maksymalna ilość przymiarek w koszyku: 2') }}</span>
      <span class="cl-error h5 w-100" v-else-if="isAddToCartDisabled && !getIsStockInfoLoading">{{ $t('Wybrany sposób dostawy nie jest dostępny') }}</span>
      <span class="cl-error h5 w-100 flex mt5 center-xs" v-show="isAddingToCart"><Spinner /> {{ $t('Rezerwujemy ten produkt') }}</span>
      <span class="cl-error h5 w-100" v-show="!getDateValidation">{{ $t('Proszę wybrać datę wypożyczenia.') }}</span>
    </div>
  </div>
</template>

<script>
import InstantCheckout from 'src/modules/vsf-instant-checkout/components/InstantCheckout.vue'
import NoSSR from 'vue-no-ssr'
import { SearchQuery } from 'storefront-query-builder'
import config from 'config'
import { mapGetters } from 'vuex'
import AddToCart from 'theme/components/core/AddToCart.vue'
import Spinner from 'theme/components/core/Spinner.vue'
import { onlineHelper } from '@vue-storefront/core/helpers'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'

export default {
  name: 'Payment',
  components: {
    InstantCheckout,
    AddToCart,
    Spinner,
    'no-ssr': NoSSR
  },
  watch: {
    isOnline: {
      handler (isOnline) {
        if (isOnline) {
          this.$store.dispatch('stock/getQuantity')
        }
      }
    }
  },
  props: {
    rentType: {
      type: String,
      default: 'single',
      required: true
    }
  },
  data () {
    return {
      subscriptions: [],
      selectedSubscription: {}
    }
  },
  computed: {
    ...mapGetters({
      isLogged: 'user/isLoggedIn',
      getDate: 'calendar/getDate',
      getCurrentProduct: 'product/getCurrentProduct',
      getUserBalance: 'user/getBalance',
      getDateValidation: 'calendar/getDateValidation',
      isAddingToCart: 'cart/getIsAdding',
      isInstantCheckoutRegistered: 'instant-checkout/getSupported',
      isCartFullOfTryOn: 'cart/isCartFullOfTryOn',
      isVirtualInCart: 'cart/isVirtualInCart',
      getIsStockInfoLoading: 'stock/getIsStockInfoLoading',
      getMaxQuantity: 'stock/getMaxQuantity',
      getAvaliableQuantity: 'calendar/getAvaliableQuantity',
      getDeliveries: 'calendar/getDeliveries',
      getActivePeriod: 'calendar/getActivePeriod'
    }),
    isSelectedSubscription () {
      return Object.keys(this.selectedSubscription).length !== 0
    },
    isSubscriptionAvaliable () {
      return this.getCurrentProduct.subscription_points
    },
    isEnoughPoints () {
      return this.getUserBalance >= 1
    },
    instantCheckoutValidation () {
      if (this.rentType === 'subscription' && !this.isLogged) return null
      if (this.rentType === 'subscription' && this.isLogged) return new Date()
      return this.getDate
    },
    activateSubscriptionValidation () {
      if (this.isLogged) return new Date()
      return null
    },
    getActiveRentPeriod () {
      if (this.getActivePeriod === 2) {
        return 1
      } else {
        return this.getActivePeriod
      }
    },
    isAddToCartDisabled () {
      return this.getIsStockInfoLoading ||
      (this.isOnline && !this.getMaxQuantity && this.getCurrentProduct.type_id === 'simple') ||
      ((this.getCurrentProduct.type_id === 'sirent' || this.getCurrentProduct.type_id === 'configurable') && (!this.getAvaliableQuantity)) ||
      (this.isCartFullOfTryOn && this.getActiveRentPeriod === 3)
    },
    isOnline () {
      return onlineHelper.isOnline
    },
    storeView () {
      return currentStoreView()
    }
  },
  async mounted () {
    await this.loadSubscriptionData()
    this.selectedSubscription = this.subscriptions[0]
  },
  methods: {
    async loadSubscriptionData () {
      let searchQuery = new SearchQuery()
      searchQuery = searchQuery
        .applyFilter({ key: 'category_ids', value: { 'in': [config.server.categoryIdsMap.fashionSubscriptionCategoryId] } });
      ({ items: this.subscriptions } = await this.$store.dispatch('product/findProducts', {
        query: searchQuery,
        sort: 'final_price:asc'
      }))
    },
    parseDesc (desc) {
      if (desc) {
        // walkaround because of different data format in magento
        desc = desc.replace(',', '.')
        let idxStart = desc.indexOf('>')
        let idxEnd = desc.indexOf('.')
        let result = desc.slice(idxStart + 1, idxEnd + 1)
        if (!result) {
          idxStart = desc.indexOf('>')
          idxEnd = desc.indexOf('</')
          return desc.slice(idxStart + 1, idxEnd)
        }
        return result
      } else {
        return ''
      }
    },
    showActivateSubscriptionModal () {
      if (!this.isLogged) return this.$bus.$emit('modal-show', 'modal-signup')
      this.$bus.$emit('modal-show', 'modal-subscription')
    },
    validateProduct () {
      if (this.rentType === 'subscription' && !this.isLogged) this.$bus.$emit('modal-show', 'modal-signup')
      this.$store.commit('calendar/setDateValidation', !!this.getDate)
    },
    updateSubscription () {
      this.$emit('updateSubscription', this.selectedSubscription)
    }
  }
}
</script>

<style lang="scss" scoped>
.radio-input {
   label {
    padding: 10px 0px;
    text-align: center;
    border: 1px solid #DCDCDC;
    color: #646464;
    display: block;
    text-transform: uppercase;
    font-size: 14px;
    cursor: pointer;
  }
  input {
    display: none;
    position: absolute;
    top: 3px;
    left: 0;
    &:checked + label {
      box-shadow: 0px 0px 0px 2px #3e3e3e !important;
      color: black;
      background-color: #F5D2D2;
    }
    &:hover,
    &:focus {
      + label {
        box-shadow: 0px 0px 0px 1px #3e3e3e;
      }
    }
    &:disabled + label {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}
.flexible {
  flex: 1;
  padding-left: 8px;
  padding-right: 8px;
}
.fs10 {
  font-size: 10px;
}
.fs13 {
  font-size: 13px;
}
.lh10 {
  line-height: 10px;
}
</style>
